import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { axiosInstance } from '../../../helpers/api_helper';
// import { TravelutionSubscriptionType } from './types';

export const getNoRenewalPass = createAsyncThunk(
  'getNoRenewalPass/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(
      '/products/travelution-no-renewal-passes/orders',
      {
        params
      }
    );

    return response.data.data;
  }
);

// export const updateSuperSalesToPaid = createAsyncThunk(
//   'getSuperSalesLicences/updateSuperSalesToPaid',
//   async (
//     { id, calculationStatus }: { id: number; calculationStatus: number },
//     { rejectWithValue }
//   ) => {
//     try {
//       await axiosInstance.post(
//         `/products/travelution-super-sales/orders/${id}/confirm?calculationStatus=${calculationStatus}`
//       );
//       toast.success('Successfully paid Super Sales license');

//       return { id, calculationStatus };
//     } catch (error: any) {
//       toast.error(error.response.data.error);
//       return rejectWithValue(error.response.data.error);
//     }
//   }
// );

export const exportHeaders = [
  { label: 'Subscription ID', key: 'subscriptionId' },
  { label: 'User ID', key: 'userId' },
  { label: 'User', key: 'user' },
  { label: 'Subscription Name', key: 'subscriptionName' },
  { label: 'Amount', key: 'amount' },
  { label: 'Payment Address', key: 'paymentAddress' },
  { label: 'Network', key: 'network' },
  { label: 'Order Date', key: 'orderDate' },
  { label: 'Payment Date', key: 'paymentDate' },
  { label: 'Start Date', key: 'startDate' },
  { label: 'End Date', key: 'endedDate' },
  { label: 'Status', key: 'status' }
];

export const statusForTable = (status: number) => {
  switch (status) {
    case 1:
      return 'PENDING';
    case 2:
      return 'PAID';
    case 3:
      return 'CANCELED';
    case 4:
      return 'CANCELED BY USER';

    default:
      break;
  }
};

export const licenceType = (status: number) => {
  switch (status) {
    case 1:
      return 'ORDER';
    case 2:
      return 'PACKAGE';
    case 3:
      return 'LICENCE';
    case 4:
      return 'COMBO';
    case 7:
      return 'TRAVELUTION SUBSCRIPTION';

    default:
      break;
  }
};

export interface GoldenCardStateInterface {
  data: any;
  loading: boolean;
  totalCount: number;
}

const initialState = {
  data: [],
  totalCount: 0,
  loading: false
} as GoldenCardStateInterface;

const getNoRenewalPassSlice = createSlice({
  name: 'getNoRenewalPassSlice',
  initialState,
  reducers: {
    // fill in primary logic here
  },
  extraReducers: (builder) => {
    builder.addCase(getNoRenewalPass.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getNoRenewalPass.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.orders;
      state.totalCount = payload.count;
    });
    builder.addCase(getNoRenewalPass.rejected, (state) => {
      state.loading = false;
    });

    // builder.addCase(updateSuperSalesToPaid.pending, (state) => {
    //   state.loading = true;
    // });
    // builder.addCase(updateSuperSalesToPaid.fulfilled, (state, { payload }) => {
    //   state.loading = false;
    //   const index = state.data.findIndex((p: any) => p.id === payload.id);

    //   state.data[index] = {
    //     ...state.data[index],
    //     status: 2,
    //     calculationStatus: payload.calculationStatus
    //   };
    // });
    // builder.addCase(updateSuperSalesToPaid.rejected, (state) => {
    //   state.loading = false;
    // });
  }
});

export default getNoRenewalPassSlice.reducer;
